<template>
  <div>
    <section id="content01">
      <section id="content02" class="box_mv">
        <div class="inner">
          <figure class="pc"><img src="../assets/img/img_mv_pc.png" width="" height="" alt=""></figure>
          <div class="ttl">
            <h1><img src="../assets/img/ttl_mv.png" width="295" height="27" alt="モデルハウスレコメンド"></h1>
            <figure class="sp"><img src="../assets/img/img_mv_sp.png" width="" height="" alt="">
            </figure>
            <p class="read">モデルハウス見学で、もう迷わない！<br>
            効率的に見学するなら、モデルハウスレコメンドを使おう！<br>
            好みや趣味に関する5つの質問から、<br>
            あなたにピッタリなモデルハウスをご紹介いたします！</p>
          </div>
        </div>
      </section>
      <div class="box_start">
        <a class="btn" v-on:click="start('q1')">START</a>
      </div>
    </section>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from '@/components/Footer.vue'

export default {
  name: 'Index',
  components: {
    Footer
  },
  methods: {
    start: function(event){
      this.$router.push(event)
    }
  }
}
</script>
